import React, { FC, useState } from "react";
import { TextLink, ViewMoreButton } from "@trussle/external-components";
import "./style.scss";
import cn from "classnames";
import { isClientSideRendering } from "../../../helpers/rendererType";
import { PanelWrapper } from "../../PanelWrapper";

interface IPanelLink {
  url: string;
  text: string;
  target: string;
}

interface ILinksPanelColumn {
  text: string;
  links: IPanelLink[];
}

export interface ILinksPanelProps {
  title?: string;
  subtitle?: string;
  linksList?: ILinksPanelColumn[];
}

const NUMBER_OF_PANEL_LINKS_TO_VIEW = 3;

const LinksPanel: FC<ILinksPanelProps> = ({ title, subtitle, linksList }) => {
  const [isViewedMore, setIsViewedMore] = useState(false);
  const [isShownViewMoreButton, setIsShownViewMoreButton] = useState(false);
  const onClickHandler = () => {
    if (isClientSideRendering()) {
      window.document.body.classList.toggle("links-panel-prevent-body-scroll");
    }
    setIsViewedMore((prevState) => !prevState);
  };

  return (
    <PanelWrapper>
      <div className="links-panel">
        <div className={cn("links-panel-wrapper", { "links-panel-wrapper-opened": isViewedMore })}>
          {title && <h3 className="links-panel-title">{title}</h3>}
          {subtitle && <h4 className="links-panel-subtitle">{subtitle}</h4>}
          {linksList && (
            <>
              <div
                className={cn("links-panel-linksList", { "links-panel-linksList-closed": !isViewedMore })}
              >
                {linksList.map((linkPanelColumn) => {
                  const { links } = linkPanelColumn;
                  if (!isShownViewMoreButton && (links.length > NUMBER_OF_PANEL_LINKS_TO_VIEW)) {
                    setIsShownViewMoreButton(true);
                  }
                  const panelLinksToView = isViewedMore ? links : links.slice(0, NUMBER_OF_PANEL_LINKS_TO_VIEW);
                  return (
                    <div key={linkPanelColumn.text} className="links-panel-column">
                      <p className="links-panel-column-heading">{linkPanelColumn.text}</p>
                      {panelLinksToView.map((panelLink) => (
                        <TextLink
                          key={panelLink.url}
                          className="links-panel-link"
                          href={panelLink.url}
                          target={panelLink.target}
                        >
                          {panelLink.text}
                        </TextLink>
                      ))}
                    </div>
                  );
                })}
              </div>
              <ViewMoreButton
                className={cn("links-panel-viewMore", { "links-panel-viewMore_show": isShownViewMoreButton })}
                onClick={onClickHandler}
              />
            </>
          )}
        </div>
      </div>
    </PanelWrapper>

  );
};

export default LinksPanel;
